export default __webpack_public_path__ + "static/media/job_details.3617079f.svg";